import { render, staticRenderFns } from "./ListCourse.vue?vue&type=template&id=4bb5c917&scoped=true&"
import script from "./ListCourse.vue?vue&type=script&lang=ts&"
export * from "./ListCourse.vue?vue&type=script&lang=ts&"
import style0 from "./ListCourse.vue?vue&type=style&index=0&id=4bb5c917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb5c917",
  null
  
)

export default component.exports